type routerModule =
    'CHAT' | // 聊天
    'CONTACT' | // 客户列表
    'CONTACT_IMPORT' | // 客户导入
    'CONTACT_SESSION' | // 会话管理
    'CONTACT_FORM' | // 表单管理
    'CONTACT_TAGS' | // 标签管理
    'CONTACT_VERBAL_TRICK' | // 话术库
    'CONTACT_MATERIAL_LIST' | // 素材库
    'MARKETING_BROADCAST_LIST' | // 消息群发
    'MARKETING_THIRD_LIST' | // 第三方代发
    'MARKETING_TEMPLATES' | // 消息模板
    'MARKETING_TEMPLATES_WHATSAPP' | // whatsapp 模板
    'MARKETING_TEMPLATES_EMAIL' | // 邮件模板
    'MARKETING_TEMPLATES_MESSENGER' | // Messenger 模板
    'AUTOMATION_FLOW' | // 自动化
    'AUTOMATION_AI_ROBOT' | // AI 机器人
    'AUTOMATION_FAQ' | // AI 语料库
    'AUTOMATION_AI_LINK' | // 分流链接
    'ANALYSIS_CHANNEL' | // 渠道分析
    'ANALYSIS_OVERVIEW' | // 服务概览
    'ANALYSIS_DURATION' | // 在线时长
    'ANALYSIS_CUSTOMER' | // 客户分析
    'ANALYSIS_REPORTS' | // 大报表
    'ANALYSIS_ADVERSTING' | // 广告分析
    'CHANNELS' | // 渠道集成
    'APP_STORE' | // 应用商店
    'FEE' | // 订阅
    'SETTING_PROJECT' | // 项目管理
    'SETTING_TEAM' | // 团队管理
    'SETTING_LOG' | // 监控日志
    'USER_INFORMATION' // 用户信息
    ;

type ModuleConfig = {
    [key in routerModule]: string;
};

const moduleConfig: ModuleConfig = {
    CHAT: 'authMode_chat', // 聊天
    CONTACT: 'contact_list', // 客户列表
    CONTACT_IMPORT: 'contact_list_import', // 客户导入
    CONTACT_SESSION: 'contact_chat_management', // 会话管理
    CONTACT_FORM: 'contact_form_management', // 表单管理
    CONTACT_TAGS: 'contact_tags', // 标签管理
    CONTACT_VERBAL_TRICK: 'contact_verbal_trick', // 话术库
    CONTACT_MATERIAL_LIST: 'contact_material_list', // 素材库
    MARKETING_BROADCAST_LIST: 'marketing_broadcast_list', // 消息群发
    MARKETING_THIRD_LIST: 'drop_shipping', // 第三方代发
    MARKETING_TEMPLATES: 'marketing_templates', // 消息模板
    MARKETING_TEMPLATES_WHATSAPP: 'marketing_templates_whatsapp', // whatsapp 模板
    MARKETING_TEMPLATES_EMAIL: 'marketing_templates_email', // 邮件模板
    MARKETING_TEMPLATES_MESSENGER: 'marketing_templates_messenger', // Messenger 模板
    AUTOMATION_FLOW: 'authMode_automation_list', // 自动化
    AUTOMATION_AI_ROBOT: 'automation_ai_robot_list', // AI 机器人
    AUTOMATION_FAQ: 'authMode_automation_ai_corpus', // AI 语料库
    AUTOMATION_AI_LINK: 'marketing_split_link', // 分流链接
    ANALYSIS_CHANNEL: 'analysis_channel', // 渠道分析
    ANALYSIS_OVERVIEW: 'analysis_data_overview', // 服务概览
    ANALYSIS_DURATION: 'analysis_online_duration', // 在线时长
    ANALYSIS_CUSTOMER: 'analysis_customer', // 客户分析
    ANALYSIS_REPORTS: 'analysis_data_analysis', // 大报表
    ANALYSIS_ADVERSTING: 'anslysis_data_adversting', // 广告分析
    CHANNELS: 'channels', // 渠道集成
    APP_STORE: 'appstore', // 应用商店
    FEE: 'fee', // 订阅
    SETTING_PROJECT: 'authMode_setting_project_management', // 项目管理
    SETTING_TEAM: 'authMode_setting_team', // 团队管理
    SETTING_LOG: 'authMode_setting_log', // 监控日志
    USER_INFORMATION: 'information', // 用户信息
};

export default moduleConfig;
